import { DesktopDatePicker as DatePicker  } from "@mui/x-date-pickers/DesktopDatePicker";
import React, { forwardRef } from "react";
import { DateVal } from "../../../utils";

interface DatePickerProps {
  value: DateVal;
  onChange: (date: DateVal) => void;
  onClickDateHandler?: () => void;
  sx?: object;
  label?: string;
  size?: string;
  ref?: React.ForwardedRef<HTMLDivElement>;
  minDate?: Date;
  maxDate?: Date;
  isValidDate?: boolean;
  helperText?: string;
  ariaLabel?: string;
  disableFuture?: boolean;
  required?: boolean;
}

const DefaultDatePicker = forwardRef<HTMLDivElement, DatePickerProps>(
  (
    {
      sx,
      size,
      minDate,
      maxDate,
      isValidDate = true,
      helperText,
      ariaLabel,
      onClickDateHandler: onClickDateHandler,
      ...rest
    },
    ref
  ) => {
    return (
      <DatePicker
        sx={{ ...sx }}
        slotProps={{
          textField: {
            size: size as "small" | "medium",
            inputProps: {
              "aria-label": ariaLabel ?? "datePicker.aria.label",
              "data-private": "true",
              "data-test-id": ariaLabel ?? "datePicker.aria.label",
              onClick: onClickDateHandler,
            },
            helperText: !isValidDate ? (
              <span aria-label={helperText}>{helperText}</span>
            ) : null,
            error: !isValidDate,
          },
        }}
        onOpen={onClickDateHandler}
        minDate={minDate}
        maxDate={maxDate}
        ref={ref}
        {...rest}
      />
    );
  }
);

DefaultDatePicker.displayName = "DefaultDatePicker";

export default DefaultDatePicker;
